// event
const MOUSEWHEEL_EVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

// animation time
const BEFORE_PJAX_TIME = 600;
const AFTER_PJAX_TIME  = 540;
const HOME_SCR_TIME    = 600;
const HOME_MV_FADE     = 6000;

// component style
var DEGREE = 60;
const COLOR = '0x009ec5';
const ALPHA = 0.7;

// canvas
let canvasLeftBgPoint,	// 背景ポイント。切り開きに使用
	canvasRightBgPoint,	// 背景ポイント。切り開きに使用
	canvasStage,	// ステージ
	slayLine;


let SITELOADER = {
	maxWidth: 300,
	width: 0,
	height: 10,
	slope: -180,
};

const RESOURCES = [
	'assets/img/home/txt_intro01_medium.png',
	'assets/img/home/txt_mv01_medium.png',
	'assets/css/lazyload.css',
	'assets/img/corpguide/bg_mv01_small.jpg',
	'assets/img/corpguide/bg_mv01_medium.jpg',
	'assets/img/corpguide/bg_mv02_medium.jpg',
	'assets/img/corpguide/bg_msg01_medium.jpg',
	'assets/img/corpguide/bg_msg01_small.jpg',
	'assets/img/corpguide/pic_leader01_small.png',
	'assets/img/corpguide/pic_leader01_medium.png',
	'assets/img/corpguide/txt_sign01.png',
	'assets/img/home/bg_intro01_medium.jpg',
	'assets/img/home/bg_intro01_small.jpg',
	'assets/img/home/bg_it01_small.jpg',
	'assets/img/home/bg_it01_medium.jpg',
	'assets/img/home/bg_it01_smmedium.jpg',
	'assets/img/home/bg_life01_medium.jpg',
	'assets/img/home/bg_life01_small.jpg',
	'assets/img/home/bg_mv01_medium.jpg',
	'assets/img/home/bg_mv01_small.jpg',
	'assets/img/home/bg_mv02_medium.jpg',
	'assets/img/home/bg_mv02_small.jpg',
	'assets/img/home/bg_mv03_medium.jpg',
	'assets/img/home/bg_mv03_small.jpg',
	'assets/img/home/bg_mv04_medium.jpg',
	'assets/img/home/bg_mv04_small.jpg',
	'assets/img/home/bg_mv05_medium.jpg',
	'assets/img/home/bg_mv05_small.jpg',
	'assets/img/home/bg_mv06_medium.jpg',
	'assets/img/home/bg_mv06_small.jpg',
	'assets/img/home/bg_mv07_medium.jpg',
	'assets/img/home/bg_mv07_small.jpg',
	'assets/img/home/bg_recruit_btn01_medium.jpg',
	'assets/img/home/bg_recruit_btn01_small.jpg',
	'assets/img/home/bg_recruit_btn02_medium.jpg',
	'assets/img/home/bg_recruit_btn02_small.jpg',
	'assets/img/home/bg_recruit_btn03_medium.jpg',
	'assets/img/home/bg_recruit_btn03_small.jpg',
	'assets/img/home/bg_recruit01_medium.jpg',
	'assets/img/home/bg_recruit01_small.jpg',
	'assets/img/home/bg_shop01_medium.jpg',
	'assets/img/home/bg_shop01_small.jpg',
	'assets/img/home/pic_it01_medium.jpg',
	'assets/img/home/pic_life01_medium.jpg',
	'assets/img/home/pic_shop01_medium.jpg',
	'assets/img/home/txt_intro01_small.png',
	'assets/img/home/txt_mv01_small.png',
	'assets/img/introduction/bg_mv01_medium.jpg',
	'assets/img/introduction/bg_mv02_medium.jpg',
	'assets/img/introduction/bg_mv01_small.jpg',
	'assets/img/introduction/img_it01.png',
	'assets/img/introduction/img_it02.png',
	'assets/img/introduction/img_it03.png',
	'assets/img/introduction/img_it04.png',
	'assets/img/introduction/img_life01_small.png',
	'assets/img/introduction/img_life01_medium.png',
	'assets/img/introduction/img_life02_small.png',
	'assets/img/introduction/img_life02_medium.png',
	'assets/img/introduction/img_life03_small.png',
	'assets/img/introduction/img_life03_medium.png',
	'assets/img/introduction/img_shop01_small.png',
	'assets/img/introduction/img_shop01_medium.png',
	'assets/img/introduction/img_shop02_small.png',
	'assets/img/introduction/img_shop02_medium.png',
	'assets/img/introduction/img_shop03_small.png',
	'assets/img/introduction/img_shop03_medium.png',
	'assets/img/module/sprites_pc.png',
	'assets/img/module/sprites_sp.png',
];

export {BEFORE_PJAX_TIME, AFTER_PJAX_TIME, MOUSEWHEEL_EVENT, HOME_SCR_TIME, DEGREE, COLOR, ALPHA, canvasLeftBgPoint, canvasRightBgPoint, canvasStage, RESOURCES, SITELOADER, HOME_MV_FADE};




// WEBPACK FOOTER //
// ./html/_src/js_wb/config.js